import { toUnit } from './currency';
import { formatPrice } from './formatPrice';

export function priceFromCents({
    amount,
    currency,
    decimalPlaces = 2,
    showSign,
}: {
    amount: number;
    currency: string;
    decimalPlaces?: number;
    showSign?: boolean;
}): string {
    return formatPrice(toUnit(amount, currency), currency, {
        maximumFractionDigits: decimalPlaces,
        signDisplay: showSign ? 'always' : 'auto',
    });
}
